/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Table,
  Typography,
  notification,
} from "antd";

import React, { useEffect, useRef, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import moment from "moment";
import SelectOption from "../../pos/components/SelectOption";
import { useHttp } from "../../../../hooks/http";
import { getToken, URL_API } from "../../../../utils";
import axios from "axios";
import SelectAllType from "../../../../components/SelectAllType";
import * as XLSX from "xlsx-js-style";
import { message } from "antdV4";

const { Text } = Typography;
const { Search } = Input;
const limit = 30;
const pageSize = 20;

const Index = () => {
  const [memberTypeFilter, setMemberTypeFilter] = useState("");
  const [memberTypeFilterText, setMemberTypeFilterText] = useState("");
  const [status, setStatus] = useState("");
  const [statusText, setStatusText] = useState("");

  const [page, setPage] = useState(1);

  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [search, setSearch] = useState("");

  const memberTypeOptions = [
    { value: "", text: "ทั้งหมด" },
    { value: "Distributor", text: "นักธุรกิจ" },
    { value: "Member", text: "VIP MEMBER" },
  ];

  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/tiktok/at-tiktok/`,
      token: true,
      params: {
        limit,
        offset: limit * (page - 1),
        query: search,
        member_type_filter: memberTypeFilter,
        member_status: status,
      },
      initialLoad: true,
    },
    [search, memberTypeFilter, status],
  );

  const exportToExcel = async () => {
    try {
      const exportDataData = data?.data ? data?.data : [];

      if (exportDataData?.length !== 0) {
        let excelData = [
          ["บัญชีผู้ใช้ TikTok"],
          [`วันที่เอกสาร  ${moment(moment()).format("DD/MM/YYYY")}`],
          [
            `ค้นหาจาก : ${search === "" ? "-" : search}`,
            "",
            `ประเภทสมาชิก : ${memberTypeFilterText === "" ? "ทั้งหมด" : memberTypeFilterText}`,
            "",
            `สถานะ : ${statusText === "" ? "ทั้งหมด" : statusText}`,
            "",
          ],
          [""],
          [
            "No",
            "ประเภทสมาชิก",
            "รหัสสมาชิก",
            "ชื่อ - นามสกุล",
            "ทีม",
            "ผู้แนะนำ",
            "ชื่อ TikTok",
            "สถานะ",
          ],
        ];

        exportDataData.forEach((n) => {
          excelData = [
            ...excelData,
            [
              { v: n.row_id, s: { alignment: { horizontal: "center" } } },
              { v: n.member_type, s: { alignment: { horizontal: "center" } } },
              { v: n.member_code, s: { alignment: { horizontal: "center" } } },
              { v: n.partner_name, s: { alignment: { horizontal: "left" } } },
              { v: n.team_name, s: { alignment: { horizontal: "left" } } },
              {
                v: n.sponsor_code + " : " + n.sponsor_name,
                s: { alignment: { horizontal: "left" } },
              },
              { v: n.account_name, s: { alignment: { horizontal: "left" } } },
              { v: n.status_text, s: { alignment: { horizontal: "center" } } },
            ],
          ];
        });

        const merge = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } },
          { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } },
          { s: { r: 2, c: 2 }, e: { r: 2, c: 3 } },
          { s: { r: 2, c: 4 }, e: { r: 2, c: 5 } },
        ];

        var wscols = [
          { wch: 10 },
          { wch: 20 },
          { wch: 15 },
          { wch: 30 },
          { wch: 12 },
          { wch: 35 },
          { wch: 30 },
          { wch: 25 },
        ];

        const ws = XLSX.utils.aoa_to_sheet(excelData);
        ws["!cols"] = wscols;
        //ws["!rows"] = wsrows;
        ws["!merges"] = merge;

        const wb = XLSX.utils.book_new();
        const fileName = `${moment().format("YYMMDD")}-บัญชีผู้ใช้TikTok.xlsx`;

        XLSX.utils.book_append_sheet(wb, ws, "บัญชีผู้ใช้ TikTok");
        XLSX.writeFile(wb, fileName);
      } else {
        notification.warning({
          message: "ไม่มีข้อมูล",
          description: "ไม่มีข้อมูลสำหรับสร้างไฟล์ excel กรุณาตรวจสอบข้อมูล",
          top: 60,
        });
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <Panel>
      <PanelHeader>@TikTok</PanelHeader>
      <PanelBody>
        <Row gutter={12} type="flex" className="align-items-center mb-5 mt-3">
          <Col span={6}>
            <Search
              placeholder="ค้นหาจาก รหัสมสมาชิก, รหัสนักธุรกิจ หรือชื่อ TikTok"
              onSearch={(value) => {
                setPage(1);
                setSearch(value);
              }}
              allowClear
            />
          </Col>
          <Col className="pl-4">
            <Text strong>ประเภทสมาชิก</Text>
          </Col>
          <Col span={4}>
            <SelectOption
              className="w-100"
              defaultValue={memberTypeFilter}
              options={memberTypeOptions}
              onChange={(value, option) => {
                setPage(1);
                setMemberTypeFilter(value);
                setMemberTypeFilterText(option?.props?.children || "");
              }}
            />
          </Col>
          <Col className="text-right pl-4">
            <Typography.Text strong className="text-nowrap">
              สถานะ
            </Typography.Text>
          </Col>
          <Col md={4}>
            <SelectAllType
              className="w-100"
              process_type={
                memberTypeFilter === "member"
                  ? "member_status_local"
                  : "partner_status_local"
              }
              withAll
              allText="ทั้งหมด"
              allowClear
              value={status}
              onChange={(value, option) => {
                setPage(1);
                setStatus(value);
                setStatusText(option?.props?.children || "");
              }}
            />
          </Col>
          <Col className="text-right pl-4">
            <Button
              type="primary"
              className="text-white d-flex align-items-center"
              icon="file-excel"
              onClick={exportToExcel}
            >
              Export Excel
            </Button>
          </Col>
        </Row>

        <Table
          bordered
          size="small"
          dataSource={data?.data.length > 0 ? data?.data : []}
          rowKey="row_id"
          loading={loading}
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: limit,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            total: data?.data.length,
            showLessItems: true,
            size: "default",
            onChange: (currPage) => setPage(currPage),
          }}
        >
          <Table.Column title="No" dataIndex="row_id" align="left" />
          <Table.Column
            title="ประเภทสมาชิก"
            dataIndex="member_type"
            align="left"
          />
          <Table.Column
            title="รหัสสมาชิก"
            dataIndex="member_code"
            align="left"
          />
          <Table.Column
            title="ชื่อ - นามสกุล"
            dataIndex="partner_name"
            align="left"
          />
          <Table.Column title="ทีม" dataIndex="team_name" align="left" />
          <Table.Column
            title="ผู้แนะนำ"
            dataIndex="sponsor_name"
            align="left"
            render={(_, record) => (
              <div>
                <div>
                  <Typography.Text>รหัส: </Typography.Text>
                  <Typography.Text>
                    {record.sponsor_code || "-"}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text>ชื่อ: </Typography.Text>
                  <Typography.Text>
                    {record.sponsor_name || "-"}
                  </Typography.Text>
                </div>
              </div>
            )}
          />
          <Table.Column
            title="ชื่อ TikTok"
            dataIndex="account_name"
            align="left"
          />
          <Table.Column title="สถานะ" dataIndex="status_text" align="left" />
        </Table>
      </PanelBody>
    </Panel>
  );
};

export default Index;
